import React from 'react';
import PropTypes from 'prop-types';
import { hashHistory } from 'react-router';
import { connect } from 'react-redux';
import $ from 'jquery';
import _ from 'lodash';
import { injectIntl } from "react-intl";

import { modifyPageLayoutComponents } from '../PageLayout';
import * as actions from '../../actions';
import * as calendarActions from '../../actions/A_Calendar';
import * as actionTypes from './../../constants/actionTypes';
import * as popupActions from './../../actions/A_Popups';
import { AccessRights } from '../../schemas/accessRightsModel';
import template from './JobBoardContent.rt';
import JobBoardHeader from './JobBoardHeader';
import PageFooterTemplate from './JobBoardFooter.rt';
import { showAssignEntityPopup } from '../../actions/A_Popups';

import {getApiConfig, getCurrentFabricatorId} from '../../utilities';
import misc from "../../misc";
import { asFabricatorId, asUserId } from "../../reducers/asCustomer";
import { messageBox_Show } from "../../actions";
import { getJobBoardTranslate } from "../../utilities/job";
import { loadPingWidget, removePingWidget } from '../../utilities/pingWidget';
import {getAuthSubDomain, hardCodeIsEncore} from "../../constants/fabricatorHardcode";
import {getReferralPrograms} from "../PageLayout/Popups/ReferralPopup/referralPopupApi";

function mapStateToProps(state, props) {
  const { jobs } = state.jobBoard;
  const { permissions, usePingWidget } = state.jobBoard;
  const { auth, asCustomer } = state;
  const {language} = state.dashboardState;

  const AR = AccessRights.get(state);
  const subDomain = getAuthSubDomain(auth, asCustomer);
  const isClient = AR.isClient();
  const isEncoreClient = hardCodeIsEncore(subDomain) && AR.isClient();

  let _jobs = jobs;
  let editJob = null;
  let signedRequestId = null;
  if (props.routeParams.editJobId) {
    _jobs = jobs.filter(j => j.jobId === props.routeParams.editJobId || j.id == props.routeParams.editJobId);
    editJob = _.first(_jobs);
    if (!editJob) {
      _jobs = jobs;
    }
    if (props.routeParams.signedRequest) {
      signedRequestId = props.routeParams.signedRequest
    }
  }
  const { bathroomSubscription, kitchenSubscription } = auth;
  const subType = misc.monads.NN(bathroomSubscription, _ => _.type, '') ||
    misc.monads.NN(kitchenSubscription, _ => _.type, '');

  return {
    term: state.jobBoard.term,
    page: state.jobBoard.page,
    sentinel: state.jobBoard.sentinel,
    totalPages: state.jobBoard.totalPages,
    loadingData: state.jobBoard.loadingData,
    jobs: _jobs,
    jobStatusDropDownVisible: state.jobBoard.jobStatusDropDownVisible,
    leadTypeDropDownVisible: state.jobBoard.leadTypeDropDownVisible,
    expandedJobId: state.jobBoard.expandedJobId,
    editableQuote: state.jobBoard.editableQuote,
    auth,
    permissions,
    AR,
    asCustomer,
    editJob,
    subscriptionType: subType,
    fabricatorLookups: auth.fabricatorLookups,
    signedRequestId,
    language,
    usePingWidget,
    isEncoreClient,
    fabricatorId: getCurrentFabricatorId(state),
    isClient,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    fetchJobs: (page, term) => dispatch(actions.fetchJobs(page, term, true)),
    expandJob: (job) => {
      dispatch(actions.expandJob(job));
      if (!job.logEntriesLoaded) {
        dispatch(actions.loadJobLogEntries(job));
      }
      if (!job.messageHistoryLoaded) {
        dispatch(actions.loadJobMessageHistory(job));
      }
    },
    toggleJobTypeDropDownVisibility: () => dispatch(actions.toggleJobTypeDropDownVisibility()),
    editQuote: (job, show) => dispatch(actions.showQuoteEditLayer(job, show)),
    showJobNotesAndUploads: (job, show, what) => dispatch(calendarActions.showScheduleEntryNotesDocumentsOnly(job, show, what)),
    exitEditQuote: (page, term) => {
      dispatch(actions.showQuoteEditLayer(null));
      dispatch(actions.fetchJobs(page, term, true));
    },
    logout: () => dispatch(actions.logout()),
    pageClick: (page, term) => dispatch(actions.fetchJobs(page, term, false)),
    showLeadTypeDropDown: (show) => dispatch(actions.showLeadTypeDropDown(show)),
    showJobStatusDropDown: (show) => dispatch(actions.showJobStatusDropDown(show)),
    showLogWindow: (data) => dispatch(actions.basicAction(actionTypes.JOB_BOARD_SHOW_LOG_WINDOW, data)),
    showJobScheduling: job => dispatch(actions.jobBoardShowJobScheduling(job, true)),
    go: path => dispatch(actions.changeLocation(path)),
    showAssignSalesPersonPopup: (job) => dispatch(popupActions.assignSalesPerson(job, true)),
    showJobBoardExport: () => dispatch(popupActions.showJobBoardExport(true)),
    showAssignEntityPopup: config => dispatch(showAssignEntityPopup(config)),
    showErrorBox: (title, text) => dispatch(messageBox_Show(true, 'error', title, text)),
    jobBoardResetPage: () => dispatch(actions.basicAction(actionTypes.JOB_BOARD_RESET_PAGE)),
  };
}

class JobBoardContent extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      markUpModalOpenedId: null,
      isLoading: true,
      showAssociateColumn: false,
    }
  }

  componentWillReceiveProps(nextProps, oldProps) {
    if (nextProps.sentinel !== this.props.sentinel && nextProps.sentinel) {
      this.props.fetchJobs(this.props.page + 1, this.props.term);
      return;
    }
    const thisAE = this.props.asCustomer ? this.props.asCustomer.activeEntity : null;
    const nextAE = nextProps.asCustomer ? nextProps.asCustomer.activeEntity : null;
    if (thisAE !== nextAE) {
      this.props.fetchJobs();
    }

    if (nextProps.editableQuote !== this.props.editableQuote && nextProps.editableQuote) {
      $('.job-board-content').addClass('job-board-content--iframe');
    } else {
      $('.job-board-content').removeClass('job-board-content--iframe');
    }

    if (nextProps.editJob && nextProps.editableQuote !== nextProps.editJob)
      this.props.dispatch(actions.showQuoteEditLayer(nextProps.editJob, true));

    if (nextProps.editableQuote) {
      $('section.app-content-wrapper').addClass('job-board-content job-board-content--iframe');
    }
  }

  // leadTypeRootNode = null;

  componentDidMount() {
    this.checkAssociate();
    this.props.fetchJobs();
    $(document).on('HIDE_QUOTE_EDIT', () => {
      this.props.dispatch(actions.showQuoteEditLayer(null));
      this.props.fetchJobs();
    });

    // this.leadTypeRootNode = ReactDOM.findDOMNode(this.refs.leadType);
    // console.log('Mounted', this.leadTypeRootNode);
    // $(document).on('click', this.handleDocumentClick);
    window.exitEditQuote = this.exitEditQuote;
    if (this.props.editableQuote) {
      $('.job-board-content').addClass('job-board-content--iframe');
      this.props.exitEditQuote(this.props.page, this.props.term);
    }
  }

  componentWillUnmount() {
    this.props.jobBoardResetPage();
    $('.job-board-content').removeClass('job-board-content--iframe');
  }

  checkAssociate = async () => {
    if (this.props.isClient) {
      this.setState({isLoading: false});
      return
    }
    try {
      const response = await getReferralPrograms(this.props.fabricatorId);
      console.log("response checkAssociate", response);
      if (Array.isArray(response) && response.length && response.filter(referral => referral.enabled)) {
        this.setState({showAssociateColumn: true})
      }
      this.setState({isLoading: false});
    } catch (e) {
      this.setState({isLoading: false});
    }
  }

  exitEditQuote = () => {
    if (this.props.editJob) {
      hashHistory.push('/jobboard');
    }
    this.props.exitEditQuote(this.props.page, this.props.term);
  };

  getAppointmentDates = (apptDates = []) => {
    const { intl } = this.props;
    let retVal = intl.formatMessage({ id: "jobBoard.appointment.none" });
    let validApptDates = [];
    for (let i = 0; i < apptDates.length; i++) {
      validApptDates.push(apptDates[i].format('MM-DD-YYYY'))
    }
    if (validApptDates.length > 0) {
      retVal = validApptDates.join(', ');
    }
    return retVal;
  }

  toggleContactPopup = (jobId) => {
    const contactPopup = document.getElementById("contact-" + jobId);
    if (!contactPopup) {
      return null
    }

    if (contactPopup.style.display === 'none') {
      contactPopup.style.display = 'flex';
    }
    else {
      contactPopup.style.display = 'none';

    }
  };

  openPingWidget = (job, selectedRole) => {
    const { auth } = this.props;
    const { language } = this.props;

    removePingWidget();

    console.log("job", job)

    let fields = [];
    if(selectedRole === "Customer"){
      fields['data-clientemail'] = job.customerInfo.email;
      fields['data-clientphone'] = job.customerInfo.phone;
    }

    if(selectedRole === 'Installer'){
      fields['data-signal'] = '138892';
    }

    if(selectedRole === 'Supplier'){
      fields['data-signal'] = '192632';
    }

    if(selectedRole === 'Store'){
      fields['data-signal'] = '139043';
    }

    loadPingWidget({
      id: "pingpilot",
      type: 'text/javascript',
      async: '',

      'data-token': auth.pingPilotAuthToken,
      'data-jobid': job.id,
      'data-fabricatorid': auth.fabricatorId,
      'data-language': language,
      'data-fabricatortype': selectedRole,
      ...fields
      //add the rest here
    });

    setTimeout(() => {
      const pingButton = document.querySelector(".pingpilot-button");
      if (!pingButton) {
        return null
      }
      pingButton.click();
    }, 1500);

  }

  // getJobType = job => {
  // if (job.isDead) {
  //   return "jobBoard.leadType.Dead_Lead"
  // }
  // if (job.isFromBV) {
  //   if (_.size(job.quotes) && job.quotes[0].subState) {
  //     const subState = job.quotes[0].subState;
  //     switch (subState) {
  //       case 'GetQuote':
  //         return "jobBoard.leadType.GetQuote";
  //       case 'DesignYes':
  //         return "jobBoard.leadType.DesignYes";
  //       case 'DesignNo':
  //         return "jobBoard.leadType.DesignNo";
  //       default:
  //         return subState;
  //     }
  //   }
  //   return "jobBoard.leadType.Design";
  // }
  // if (job.salesPerson) {
  //   return "Quote"
  // }
  // return "Lead"
  // return job.type

  // return getLeadTranslate(job);
  // }

  handleMoreInfoClick = (job) => {
    const { asCustomer, auth } = this.props;
    switch (this.props.subscriptionType) {
      case 'free':
        // hashHistory.push(`/account?entityId=${asUserId(asCustomer) || auth.userId}&clientType=Client`);
        const service = job.isFromBV ? 'bathroom' : 'kitchen';
        location.href = `/dashboard/?fabId=${asFabricatorId(asCustomer) || auth.fabricatorId}&service=${service}#/purchase`;
        break;
      default:
        this.props.expandJob(job)
        break;
    }
  }

  isAmericanImport = () => {
    const { asCustomer, auth } = this.props;
    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    switch (fabricatorId) {
      case 140460: //American Import
      case 155479: //American Standard 2020
      case 251108: //American Standard - Cory on QKB Production
      case 246514: //American Standard - Cory_Import_2024-09-12-06:34
      case 249947: //American Standard ASHS & Safety Tubs_Import_2024-10-28-10:37
      case 251037: //American Standard ASHS & Safety Tubs_12/11/2025
        return true;
    }
    return false;
  }

  usePingWidget = () =>{
    const {usePingWidget} = this.props;
    return usePingWidget;
  }

  selectLeadType = (text, job, action, oldLeadType) => {
    const { intl } = this.props;
    this.props.showLogWindow({
      jobId: job.id,
      oldLeadType: oldLeadType || job.leadType,
      newLeadType: text,
      jobIdType: job.jobIdType,
      isDead: job.isDead,
      show: true,
      logEntry: { message: '' },
      status: intl.formatMessage({ id: getJobBoardTranslate(job.status) }),
      action: action || 'changeLeadType',
      type: job.type
    })
  };

  showFabricatorsPopup = (job) => {
    const { intl } = this.props;
    this.props.showAssignEntityPopup({
      visible: true,
      entitiesType: 'fabricators',
      headerText: intl.formatMessage({ id: "assignEntityPopup.changeJobAssociation" }),
      hideLicensedAdminCheckBoxes: true,
      singleSelection: true,
      activeFabricatorIdJob: job.fabricatorId,
      saveAction: selectedFabricators => {
        return new Promise((resolve) => {
          if (_.isEmpty(selectedFabricators)) {
            this.props.showErrorBox('A fabricator must be selected.');
            resolve();
            return;
          }

          const { post } = getApiConfig('JobBoard/update-job-fabricator');
          post({ jobId: job.id, newFabricatorId: selectedFabricators[0] })
            .then(() => {
              this.props.fetchJobs(this.props.page + 1); // we keep in state page starting from 0, but pager counts from 1
              resolve();
            })
        })
      }
    })
  }

  updateJobLookups(job, lookupName, lookupNewValue) {
    // 1) show notes modal
    let noteModalActionType = "freeText";
    let newJobType = "";
    if ((lookupName === "dispositionId")) { // let the job type be changed(old logic)
      if (lookupNewValue === 2 && job.type !== "Job") {
        noteModalActionType = null;
        newJobType = "Job";
      } else if (job.type === "Job" && lookupNewValue !== 2) {
        noteModalActionType = null;
        newJobType = "Quote";
      }
    }
    this.selectLeadType(newJobType, job, noteModalActionType, job.status);

    // 2) save current lookup
    const { post } = getApiConfig('JobBoard/update-job-lookups');
    job.lookups[lookupName] = lookupNewValue;
    post({
      jobId: job.id,
      ...job.lookups
    })
      .then((res) => {
        // console.log(`Job Lookup ${lookupName} was updated ${res}`);
        this.forceUpdate();
      });
  }

  markUpArrowsClick = (job) => {
    // console.log("job", job);
    if (!job.markUpLogic) {
      if (this.state.markUpModalOpenedId) {
        this.setState({markUpModalOpenedId: null})
      }
      return
    }
    this.setState({markUpModalOpenedId: this.state.markUpModalOpenedId === job.id ? null : job.id})
  }

  getAssociateName = (job) => {
    if (!job.jobOrder) {
      return "None"
    }
    const jobOrder = job.jobOrder ? JSON.parse(job.jobOrder) : {};
    return jobOrder.childFabricatorName || "None";
  }

  render() {
    if (this.state.isLoading) {
      return <div className="ui-loader absolute" style={{
        top: 0,
        left: 0,
        bottom: 0,
        height: "calc(100% + 111px)"
      }}/>
    }
    return template.apply(this);
  }
}

JobBoardContent.propTypes = {
  expandJob: PropTypes.func.isRequired,
  fetchJobs: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  expandedJobId: PropTypes.number
};

const connector = connect(mapStateToProps, mapDispatchToProps);

const JobBoardContentContainer = injectIntl(
  connector(JobBoardContent)
);

export const JobBoardLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(JobBoardHeader),
  content: JobBoardContentContainer,
  pageFooter: connector(PageFooterTemplate)
});

